import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {getCategoryPathForSelection} from '~/selectors/ProductSelectors';
import {swapProduct, addProduct} from '~/actions/ProductActions';

export const useProductSelection = (fireStyleMetrics, selectedProduct) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const categoryPath = useSelector(getCategoryPathForSelection);

  const handleComplementSelected = (style, colorId, onComplementClick) => {
    fireStyleMetrics(style, selectedProduct.styleId);
    onComplementClick(style.id, colorId);
  };

  const handleAlternativeSelected = (style, colorId, styleId) => {
    fireStyleMetrics(style, selectedProduct.styleId);
    const nextStyle = {
      categoryPath,
      colorId,
      styleId: style.id
    };

    if (style.id === styleId) {
      dispatch(
        swapProduct({
          previousColorId: colorId,
          previousStyleId: styleId,
          nextProduct: nextStyle
        })
      );
    } else {
      dispatch(
        addProduct({
          metricsEnabled: false,
          products: [nextStyle],
          urlPath: window.location.hash
        })
      );
    }
    navigate('/');
  };

  return {
    handleComplementSelected,
    handleAlternativeSelected
  };
};
